import { takeLatest, call, put } from "redux-saga/effects";
import aitsApi from "./aitsApi";

import {
  fetchAitsTestListRequest,
  fetchAitsTestListSuccess,
  fetchAitsTestListFailure,
  fetchAitsSyllabusRequest,
  fetchAitsSyllabusSuccess,
  fetchAitsSyllabusFailure,
  clearAitsSyllabus,
} from "./aitsSlice";

// function* fetchAitsTestListWorker(action) {
//   try {
//     const {
//       paperType,
//       plannerId,
//       plannerTestType,
//       page,
//       year,
//       format,
//       categoryId,
//     } = action.payload;

//     const response = yield call(aitsApi.getAitsTestList, {
//       paperType,
//       plannerId,
//       plannerTestType,
//       page,
//       year,
//       format,
//       categoryId,
//     });

//     if (response?.status === 200) {
//       const tabs = response?.tabs || response?.data?.tabs || ["All Tests"];

//       const list = response?.data?.data || [];

//       yield put(fetchAitsTestListSuccess({ list, tabs }));
//     } else {
//       throw new Error(response?.message || "Invalid API response");
//     }
//   } catch (error) {
//     yield put(fetchAitsTestListFailure(error.message));
//   }
// }
function* fetchAitsTestListWorker(action) {
  try {
    const {
      paperType,
      plannerId,
      plannerTestType,
      year,
      format,
      categoryId,
    } = action.payload;

    let page = 1;
    let allTests = [];
    let tabs = [];

    while (true) {
      const response = yield call(aitsApi.getAitsTestList, {
        paperType,
        plannerId,
        plannerTestType,
        year,
        format,
        categoryId,
        page,
      });

      if (response?.status !== 200) break;

      if (page === 1) {
        tabs = response?.tabs || response?.data?.tabs || [];
      }

      const pageData = response?.data?.data || [];
      allTests = [...allTests, ...pageData];

      const lastPage = response?.data?.last_page;
      if (!lastPage || page >= lastPage) break;

      page++;
    }

    yield put(fetchAitsTestListSuccess({ list: allTests, tabs }));
  } catch (error) {
    yield put(fetchAitsTestListFailure(error.message));
  }
}


function* fetchAitsSyllabusWorker(action) {
  try {
    const response = yield call(aitsApi.getAitsSyllabus, action.payload);

    if (response?.status === 200) {
      yield put(fetchAitsSyllabusSuccess(response.data));
    } else {
      throw new Error(response?.message || "Failed to fetch syllabus");
    }
  } catch (error) {
    yield put(fetchAitsSyllabusFailure(error.message));
  }
}


export default function* aitsSaga() {
  yield takeLatest(fetchAitsTestListRequest.type, fetchAitsTestListWorker);
   yield takeLatest(fetchAitsSyllabusRequest.type, fetchAitsSyllabusWorker);
}
